import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconCommunicationComment16 } from '@cian/ui-kit-design-tokens/icons';
import { Link } from '../Link';
import { trackAnswersClick } from './tracking';

export interface IReviewAnswersProps {
  reviewId: string;
  fullUrl: string;
  answersCount: number;
}

export const ReviewAnswers: React.FC<IReviewAnswersProps> = ({ reviewId, fullUrl, answersCount }) => {
  return (
    <Link url={`${fullUrl}otzyvy/#${reviewId}`} target="blank" linkStyle={{ display: 'block' }}>
      <IconButton Icon={IconCommunicationComment16} label={answersCount} onClick={() => trackAnswersClick('')} />
    </Link>
  );
};
